// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Icon } from 'semantic-ui-react'

export default class MakerNavig extends Component {
  redo = (e) => {
    window.location.reload()
  }
  render () {
    let { manageComp, loading, error, out } = this.props
    return (
      <div className='mb center'>
        {loading && (
          <Button color='black' loading>
            Loading...
          </Button>
        )}
        {!loading && !error && (
          <div>
            <Button.Group>
              <Button
                basic={manageComp}
                color='black'
                onClick={this.props.manageCompFunc}
                disabled={out}
                style={{
                  marginRight: '1vh'
                }}
                size='medium'>
                {!manageComp ? 'Launch Editor' : 'Close Editor'}
              </Button>
              {out && <Button color='blue' icon='redo' onClick={this.redo} />}
            </Button.Group>
          </div>
        )}
      </div>
    )
  }
}
